import { useState, useCallback } from 'react';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import ProductsSection from './components/ProductsSection';
import ClosingSection from './components/ClosingSection';
import Footer from './components/Footer';
import WaitlistModal from './components/WaitlistModal';
import styles from './App.module.css';

export default function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = useCallback(() => setModalOpen(true), []);
  const closeModal = useCallback(() => setModalOpen(false), []);

  return (
    <div className={styles.app}>
      <Hero onOpenWaitlist={openModal} />
      <ProblemSection onOpenWaitlist={openModal} />
      <ProductsSection onOpenWaitlist={openModal} />
      <ClosingSection onOpenWaitlist={openModal} />
      <Footer />
      <WaitlistModal open={modalOpen} onClose={closeModal} />
    </div>
  );
}
